<template>
  <div class="home-box">
    <div class="box">
      <div class="box-title">
        <div :class="active==index?'title-active':''" :key="index" @click="activeIndex(item,index)" v-for="(item,index) in typeList">{{item.name}}</div>
      </div>
      <div class="box-title1">
        <div class="t1-l">
          <div class="t1-l-in">
            <el-date-picker
              size="small"
              v-model="search.createTime"
              value-format="yyyy-MM-dd"
              type="date"
              clearable
              placeholder="选择日期">
            </el-date-picker>
          </div>
          <div class="btn" style="margin-left:10px" @click="getData">搜索</div>
        </div>
        <div class="t1-r btn" @click="enter">新增</div>
      </div>
      <div class="scroll" @mouseover="yr" @mouseout="yc">
        <div class="scroll-l"><img @click="lunbo" src="../../../assets/image/new/路径.png" alt=""></div>
        <div class="scroll-r"><img @click="aaa" src="../../../assets/image/new/路径.png" alt=""></div>
        <div class="s-item">
          <div class="item" :style="item.left" @click="enter1(item)" v-for="(item,index) in imgList" :key="index">
            <img :src="aa+item.imgContent" alt="">
            <div>{{item.name}}</div>
          </div>
        </div>
      </div>
      <div class="box-btm">
        <div class="box-btm-cont">
          <div class="ll" style="padding:1vw 0">
            <div class="row" @click="enter1(item)" v-for="item in dataList">
              <div class="row-l"><div class="name">{{item.name}}</div>：<div class="s-title">{{item.newsTitle}}</div></div>
              <div class="row-r">{{item.createDate}}</div>
            </div>
          </div>
          <div class="mm"></div>
          <div class="rr" style="padding:1vw 0">
            <div class="row"  @click="enter1(item)" v-for="item in dataList1">
              <div class="row-l"><div class="name">{{item.name}}</div>：{{item.newsTitle}}</div>
              <div class="row-r">{{item.createDate}}</div>
            </div>
          </div>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="search.pageNum"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
  export default {
    data() {
      return {
        typeList: [
          {
            name:'永远的丰碑',
            value:13
          },
        ],
        active:0,
        search:{
          newsType:13,
          projectId:util.session.get('groupId'),
          createTime:'',
          pageSize:26,
          pageNum:1,
          moduleType:'redchina'
        },
        dataList:[],
        dataList1:[],
        total:0,
        aa:base.httpCtx,
        imgList:[],
        time:null,
        falg:false,
        move:true,
        lock:true,
        lock1:false
      }
    },
    beforeDestroy(){
      if(this.time!=null){
          clearInterval(this.time)
        }
    },
    mounted(){
      this.getData()
      // this.aaa()
      this.getShowImg()
    },
    methods:{
      yr(){
        if(this.time!=null){
          clearInterval(this.time)
          this.time=null
        }
      },
      yc(){
        if(this.lock1){
              this.time = setInterval(() => {
              this.lunbo1()
            }, 3000);
            }
      },
      aaa(){
        document.querySelectorAll('.item').forEach((item,index)=>{
          item.style.left = index*8.2+'vw'
        })
      },
      lunbo(){
        let a = setInterval(()=>{
          document.querySelectorAll('.item').forEach((item,index)=>{
          item.style.left = index*8.2-0.1+'vw'
        })
          if(document.querySelectorAll('.item')[1].style.left='0px'){
            clearInterval(a)
          }
        },100)
      },
      lunbo1(){
         if(this.lock1){
           if(this.lock){
            this.lock=false
          this.move=true
          this.falg=true
          setTimeout(()=>{
            this.imgList.push(this.imgList[0])
          
          this.falg=false
          this.imgList.shift()
          this.lock=true
          },2000)
          }
         }
      },
      getShowImg(){
        myHttp.getShowImg({
          projectId:util.session.get('groupId')
        }).then(res=>{
          console.log(window)
          if(res.data.code==200){
            this.imgList = res.data.data
            // if(this.lock1){
            //   this.time = setInterval(() => {
            //   this.lunbo1()
            // }, 5000);
            // }
          }
        })
      },
      handleSizeChange(val){
        this.search.pageSize = val
        this.search.pageNum = 1
        this.getData()
      },
      handleCurrentChange(val){
        this.search.pageNum = val
        this.getData()
      },
      getData(){
        this.dataList=[]
        this.dataList1=[]
        myHttp.findInfo(this.search).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.total = res.data.data.pageInfo.total
            res.data.data.pageInfo.list.forEach((item,index)=>{
              if(item.imgContent!=''){
                let a = item.imgContent.split(',')
                item.imgContent = a
              }
              if(index<=12){
                this.dataList.push(item)
              }else if(index>12){
                this.dataList1.push(item)
              }
            })
            // this.dataList = res.data.data.pageInfo.list
          }
        })
      },
      activeIndex(item,index){
        this.search.newsType = item.value
        this.active=index
        this.getData()
      },
      enter(){
        this.$router.push({
          path:'/redPropagandaAdd',
          query:{
            type:1
          }
        })
      },
      enter1(item){
        this.$router.push({
          path:'/redPropagandaItem',
          query:{
            id:item.id
          }
        })
      }
    }
  }
</script>

<style scoped>
  .home-box{
    width: 100%;
    height: 100%;
    background-color: rgb(245,245,245);
    padding: 10px 24px 10px 16px;
  }
  .box{
    width: 100%;
    height: 100%;
    border-radius: 0px 0px 6px 6px;
    overflow: hidden;
  }
  .box-title{
    height: 5.5vh;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
    padding-left:16px;
    display: flex;
  }
  .box-title>div{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
    margin-right: 22px;
    cursor: pointer;
  }
  .box-title>div:hover{
    opacity: 0.7;
  }
  .title-active{
    border-bottom: 2px solid #4D6EB1;
  }
  .box-title1{
    margin-top:1.1vh;
    height: 5.5vh;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
  }
  .t1-l{
    height: 100%;
    display: flex;
  }
  .btn{
    width: 52px;
    height: 100%;
    border-radius: 4px;
    background: #3871E5;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #FFFFFF;
  }
  .btn:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  .scroll{
    position: relative;
    margin-top: 10px;
    height: 19.2vh;
    padding: 0 2.8vw;
    border-radius: 6px;
    background: #FFFFFF;
     overflow: hidden;
    box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
  }
  .scroll-l{
    position: absolute;
    left: 0;
    height: 100%;
    width: 2.8vw;
    z-index: 200;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .scroll-r{
    position: absolute;
    right: -1px;
    height: 100%;
    width: 2.8vw;
    z-index: 200;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: rotate(180deg);
  }
  .scroll-r>img:hover,.scroll-l>img:hover{
    cursor: pointer;
    opacity: 0.7;
  }
  .s-item{
    width: 100%;
    height: 19.3vh;
    display: flex;
    margin-top: 1vh;
    align-items: center;
    position:relative;
  }
  .item{
    margin-right: 1.5vw;
    position: absolute;
  }
  .item:hover{
    cursor: pointer;
    opacity: 0.7;
  }
  .item>img{
    width: 6.7vw;
    height: 14.9vh;
  }
   .move{
      transition: all 2s;
      transform: translateX(-8.2vw) !important;
 }

 .move1{
      transition: all 2s;
      transform: translateX(8.2vw);
 }
  .item>div{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
  }
  .box-btm{
    margin-top: 1vh;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
  }
  .box-btm-cont{
    height: 49vh;
    display: flex;
    position: relative;
  }
  .el-pagination{
    box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
  }
  .ll{
    width: 50%;
    height: 100%;
  }
  .mm{
    position: absolute;
    left: 38.5%;
    top: 50%;
    width: 41vh;
    height: 1px;
    transform: rotate(90deg);
    background: linear-gradient(270deg, rgba(204,1,1,0.00) 0%, rgba(204,1,1,0.00) 0%, #CC0101 52%, rgba(204,1,1,0.00) 100%, rgba(204,1,1,0.00) 100%);
  }
  .rr{
    width: 50%;
    height: 100%;
  }
  .row{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1vh;
    padding: 0 1vw;
  }
  .row>div{
    font-family: SourceHanSansCN-Regular;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
  }
  .name{
    /* display: flex; */
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #666666;
    text-align: justify;
text-align-last: justify;
width: 3vw;
  }
  .s-title{
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #666666;
    width: 29vw;
    overflow: hidden;
    text-overflow:ellipsis;
    text-align: start;
    white-space:nowrap;
  }
  .row-l{
    display: flex;
    width: 33vw;
    overflow: hidden;
  }
  .row:hover{
    opacity: 0.7;
    cursor: pointer;
  }
</style>